import React from "react"
import {HttpService} from "../../service/HttpService";
import {Custom} from "../Custom";
import HistoryPDADetail from "../../components/Profile/Sections/HistoryPDADetail";

export const HistoryPdaDetailPage: React.FC = () => {
    const customProject = HttpService?.customProject

    return (
        <>
            {
                customProject?.customFrontend &&
                customProject?.frontendComponents?.some(component => component?.pathUrl === `/history-pda-detail-custom`)
                    ? <Custom customFrontendUrl={customProject?.customFrontendUrl}
                              type={customProject?.frontendComponents?.find(comp => comp?.pathUrl === `/history-pda-detail-custom`)?.component}
                    />
                    :
                    <HistoryPDADetail />
            }
        </>
    )
}